import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import AdvertisementFormLayer from "../components/AdvertisementFormLayer";

const AdvertisementFormPage = () => {
    return (
        <MasterLayout>
            <AdvertisementFormLayer />
        </MasterLayout>
    );
};

export default AdvertisementFormPage;
